import { render } from "./EditHabitantModal.vue?vue&type=template&id=6a6ada33"
import script from "./EditHabitantModal.vue?vue&type=script&lang=js"
export * from "./EditHabitantModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__